window.BASE_RENDER = Object.freeze({
  id: "base",
  label: "Base",
  suffix: ""
});

window.PERSONAS = {
  couch_potato: {
    key: "couch_potato",
    label: "Couch Potato",
    prompt:
      "Place the dog resting on a soft couch or blanket. Warm ambient lighting, plush textures, and a calm relaxed atmosphere. The dog appears comfortable and content, embodying a lovable stay-at-home companion enjoying a peaceful moment indoors."
  },
  world_pup: {
  key: "world_pup",
  label: "World Pup",
  prompt:
    "Place the dog on a professional outdoor soccer pitch inside a packed modern stadium under dramatic floodlights. The environment should feel like an elite international tournament with cheering supporters, waving flags, raised scarves, and premium sports-poster energy. The dog should appear confident, proud, and heroic as the clear star of the scene."
},
  adventurer: {
    key: "adventurer",
    label: "Adventurer",
    prompt:
      "Place the dog in a scenic outdoor landscape such as mountains, forest trail, or arctic view. The dog stands confidently as an explorer wearing a US flag bandana. The mood is uplifting, adventurous, and energetic with expansive natural scenery."
  },

  royalty: {
    key: "royalty",
    label: "Royalty",
    prompt:
      "Place the dog in an elegant royal palace setting with tall windows, marble floors, and grand columns. The dog wears a jeweled crown and sits or stands in a dignified pose. The atmosphere is refined, noble, and majestic with large paintings in a luxurious surrounding."
  },

  superhero: {
    key: "superhero",
    label: "Superhero",
    prompt:
      "Place the dog in a heroic action setting with a flowing cape and confident stance. The dog appears powerful and triumphant, positioned like a heroic protector. The background may include a city skyline or dramatic sky suggesting action and strength."
  },

  chef: {
    key: "chef",
    label: "Chef",
    prompt:
      "Place the dog in a refined kitchen area or a 5-star restaurant setting wearing a traditional white chef hat. The environment includes culinary elements such as countertops, cooking tools, or plated food. The mood is playful, polished, and welcoming, celebrating the joy of cooking."
  },

  beach_day: {
    key: "beach_day",
    label: "Beach Day",
    prompt:
      "Place the dog in a bright sunny beach setting with ocean waves and open sky in the background. The dog relaxes on a colorful beach towel. Optional accessory: sunglasses. The mood is carefree, joyful, and relaxed with fresh ocean air and warm sunshine."
  }
};

window.PERSONA_STYLE_VARIANTS = {

couch_potato: [

/* REAL */

{ id: "couch_real_fireplace_evening", label: "Fireplace Evening", suffix: `Scene: cozy living room couch with warm fireplace glow.` },

{ id: "couch_real_movie_night", label: "Movie Night", suffix: `Scene: dim living room couch illuminated by television light.` },

{ id: "couch_real_lamp_corner", label: "Lamp Corner", suffix: `Scene: warm lamp-lit couch corner with pillows and blankets.` },

{ id: "couch_real_snack_guard", label: "Snack Guard", suffix: `Scene: cozy couch with snacks nearby.` },

{ id: "couch_real_blanket_nest", label: "Blanket Nest", suffix: `Scene: couch piled with cozy blankets and cushions.` },

/* HYBRID */

{ id: "couch_hybrid_storybook_lounge", label: "Storybook Lounge", suffix: `Scene: illustrated living room couch with warm evening light.` },

{ id: "couch_hybrid_fireplace_portrait", label: "Fireplace Portrait", suffix: `Scene: stylized fireplace living room lounge.` },

{ id: "couch_hybrid_vintage_evening", label: "Vintage Evening", suffix: `Scene: nostalgic illustrated living room with lamp glow.` },

{ id: "couch_hybrid_pillow_stack", label: "Pillow Stack", suffix: `Scene: couch stacked with plush pillows.` },

{ id: "couch_hybrid_soft_lounge", label: "Soft Lounge", suffix: `Scene: softly illustrated cozy couch interior.` },

/* CARTOON */

{ id: "couch_cartoon_cozy_guard", label: "Snack Guard", suffix: `Scene: animated couch lounge with snacks nearby.` },

{ id: "couch_cartoon_blanket_king", label: "Blanket King", suffix: `Scene: cartoon couch buried in cozy blankets.` },

{ id: "couch_cartoon_lazy_evening", label: "Lazy Evening", suffix: `Scene: animated living room couch at night.` },

{ id: "couch_cartoon_movie_guard", label: "Movie Guard", suffix: `Scene: cartoon couch watching television.` },

{ id: "couch_cartoon_plush_lounge", label: "Plush Lounge", suffix: `Scene: colorful cartoon couch with oversized cushions.` }

],
world_pup: [
  /* =========================
     REAL
  ========================= */
  { id: "world_pup_real_brazil", label: "Brazil — Real", styleBucket: "real" },
  { id: "world_pup_real_germany", label: "Germany — Real", styleBucket: "real" },
  { id: "world_pup_real_england", label: "England — Real", styleBucket: "real" },
  { id: "world_pup_real_usa", label: "United States — Real", styleBucket: "real" },
  { id: "world_pup_real_spain", label: "Spain — Real", styleBucket: "real" },
  { id: "world_pup_real_france", label: "France — Real", styleBucket: "real" },

  /* =========================
     HYBRID
  ========================= */
  { id: "world_pup_hybrid_brazil", label: "Brazil — Hybrid", styleBucket: "hybrid" },
  { id: "world_pup_hybrid_germany", label: "Germany — Hybrid", styleBucket: "hybrid" },
  { id: "world_pup_hybrid_england", label: "England — Hybrid", styleBucket: "hybrid" },
  { id: "world_pup_hybrid_usa", label: "United States — Hybrid", styleBucket: "hybrid" },
  { id: "world_pup_hybrid_spain", label: "Spain — Hybrid", styleBucket: "hybrid" },
  { id: "world_pup_hybrid_france", label: "France — Hybrid", styleBucket: "hybrid" },

  /* =========================
     CARTOON
  ========================= */
  { id: "world_pup_cartoon_brazil", label: "Brazil — Cartoon", styleBucket: "cartoon" },
  { id: "world_pup_cartoon_germany", label: "Germany — Cartoon", styleBucket: "cartoon" },
  { id: "world_pup_cartoon_england", label: "England — Cartoon", styleBucket: "cartoon" },
  { id: "world_pup_cartoon_usa", label: "United States — Cartoon", styleBucket: "cartoon" },
  { id: "world_pup_cartoon_spain", label: "Spain — Cartoon", styleBucket: "cartoon" },
  { id: "world_pup_cartoon_france", label: "France — Cartoon", styleBucket: "cartoon" }
],
beach_day: [

/* REAL */

{ id: "beach_real_surf_guard", label: "Surf Guard", suffix: `Scene: sunny shoreline beach.` },

{ id: "beach_real_sunglasses", label: "Beach Shades", suffix: `Scene: bright sandy beach.` },

{ id: "beach_real_towel_lounge", label: "Towel Lounge", suffix: `Scene: beach towel near ocean waves.` },

{ id: "beach_real_inner_tube", label: "Float Patrol", suffix: `Scene: shallow ocean water along beach.` },

{ id: "beach_real_boardwalk", label: "Boardwalk Stroll", suffix: `Scene: seaside boardwalk near the beach.` },

/* HYBRID */

{ id: "beach_hybrid_surf_scene", label: "Surf Scene", suffix: `Scene: stylized beach shoreline with waves.` },

{ id: "beach_hybrid_summer_shade", label: "Summer Shade", suffix: `Scene: beach umbrella and sand.` },

{ id: "beach_hybrid_dunes", label: "Sunny Dunes", suffix: `Scene: coastal sand dunes overlooking ocean.` },

{ id: "beach_hybrid_wave_watch", label: "Wave Watch", suffix: `Scene: stylized ocean shoreline.` },

{ id: "beach_hybrid_boardwalk", label: "Boardwalk Breeze", suffix: `Scene: illustrated seaside boardwalk.` },

/* CARTOON */

{ id: "beach_cartoon_surf_hero", label: "Surf Hero", suffix: `Scene: animated beach shoreline.` },

{ id: "beach_cartoon_sun_lounge", label: "Sun Lounge", suffix: `Scene: cartoon beach with colorful towel.` },

{ id: "beach_cartoon_wave_rider", label: "Wave Rider", suffix: `Scene: animated waves crashing on beach.` },

{ id: "beach_cartoon_tube_float", label: "Tube Float", suffix: `Scene: playful cartoon beach water.` },

{ id: "beach_cartoon_boardwalk", label: "Boardwalk Fun", suffix: `Scene: colorful cartoon seaside boardwalk.` }

],

royalty: [

/* REAL */

{ id: "royalty_real_throne_room", label: "Throne Room", suffix: `Scene: grand palace throne room.` },

{ id: "royalty_real_ceremonial_hall", label: "Ceremonial Hall", suffix: `Scene: elegant royal ceremonial hall.` },

{ id: "royalty_real_palace_garden", label: "Palace Garden", suffix: `Scene: palace garden with fountains.` },

{ id: "royalty_real_state_portrait", label: "State Portrait", suffix: `Scene: royal portrait chamber.` },

{ id: "royalty_real_window_light", label: "Window Light", suffix: `Scene: palace interior lit by tall windows.` },

/* HYBRID */

{ id: "royalty_hybrid_gilded_throne", label: "Gilded Throne", suffix: `Scene: illustrated palace throne room.` },

{ id: "royalty_hybrid_court_portrait", label: "Court Portrait", suffix: `Scene: stylized royal palace court.` },

{ id: "royalty_hybrid_palace_garden", label: "Garden Regent", suffix: `Scene: illustrated royal garden.` },

{ id: "royalty_hybrid_royal_hall", label: "Royal Hall", suffix: `Scene: decorative palace hall.` },

{ id: "royalty_hybrid_velvet_chamber", label: "Velvet Chamber", suffix: `Scene: ornate palace chamber.` },

/* CARTOON */

{ id: "royalty_cartoon_crown_keeper", label: "Crown Keeper", suffix: `Scene: animated palace throne room.` },

{ id: "royalty_cartoon_scepter_day", label: "Scepter Day", suffix: `Scene: colorful cartoon royal hall.` },

{ id: "royalty_cartoon_palace_garden", label: "Garden Prince", suffix: `Scene: animated palace garden.` },

{ id: "royalty_cartoon_throne_star", label: "Throne Star", suffix: `Scene: cartoon throne room.` },

{ id: "royalty_cartoon_royal_window", label: "Royal Window", suffix: `Scene: animated palace window chamber.` }

],

superhero: [

/* REAL */

{ id: "superhero_real_rooftop_guardian", label: "Rooftop Guardian", suffix: `Scene: rooftop overlooking city skyline.` },

{ id: "superhero_real_storm_watch", label: "Storm Watch", suffix: `Scene: rooftop with storm clouds above city.` },

{ id: "superhero_real_city_emblem", label: "City Emblem", suffix: `Scene: glowing city skyline at dusk.` },

{ id: "superhero_real_sunrise_roof", label: "Sunrise Roof", suffix: `Scene: sunrise skyline from rooftop.` },

{ id: "superhero_real_comic_storm", label: "Storm Protector", suffix: `Scene: city skyline under dramatic clouds.` },

/* HYBRID */

{ id: "superhero_hybrid_comic_rooftop", label: "Comic Rooftop", suffix: `Scene: stylized rooftop skyline.` },

{ id: "superhero_hybrid_storm_signal", label: "Storm Signal", suffix: `Scene: illustrated skyline under storm clouds.` },

{ id: "superhero_hybrid_skyline_watch", label: "Skyline Watch", suffix: `Scene: poster-style city skyline.` },

{ id: "superhero_hybrid_action_frame", label: "Action Frame", suffix: `Scene: dynamic comic city backdrop.` },

{ id: "superhero_hybrid_dawn_guardian", label: "Dawn Guardian", suffix: `Scene: sunrise skyline over city.` },

/* CARTOON */

{ id: "superhero_cartoon_rooftop_hero", label: "Rooftop Hero", suffix: `Scene: animated city rooftop.` },

{ id: "superhero_cartoon_storm_chaser", label: "Storm Chaser", suffix: `Scene: cartoon storm clouds above city.` },

{ id: "superhero_cartoon_city_guard", label: "City Guard", suffix: `Scene: bright animated skyline.` },

{ id: "superhero_cartoon_action_pose", label: "Action Pose", suffix: `Scene: comic-style city action background.` },

{ id: "superhero_cartoon_sunrise_saver", label: "Sunrise Saver", suffix: `Scene: animated sunrise skyline.` }

],

chef: [

/* REAL */

{ id: "chef_real_bistro_critic", label: "Bistro Critic", suffix: `Scene: upscale bistro table.` },

{ id: "chef_real_classic_chef", label: "Classic Chef", suffix: `Scene: restaurant kitchen plating station.` },

{ id: "chef_real_test_kitchen", label: "Test Kitchen", suffix: `Scene: modern chef test kitchen.` },

{ id: "chef_real_bakery_counter", label: "Bakery Counter", suffix: `Scene: artisan bakery counter.` },

{ id: "chef_real_signature_plate", label: "Signature Plate", suffix: `Scene: chef plating gourmet dish.` },

/* HYBRID */

{ id: "chef_hybrid_bistro_story", label: "Bistro Story", suffix: `Scene: stylized bistro interior.` },

{ id: "chef_hybrid_menu_master", label: "Menu Master", suffix: `Scene: illustrated restaurant kitchen.` },

{ id: "chef_hybrid_bakery_day", label: "Bakery Day", suffix: `Scene: illustrated bakery counter.` },

{ id: "chef_hybrid_critic_corner", label: "Critic Corner", suffix: `Scene: decorative restaurant table.` },

{ id: "chef_hybrid_kitchen_glow", label: "Kitchen Glow", suffix: `Scene: warm illustrated kitchen.` },

/* CARTOON */

{ id: "chef_cartoon_food_critic", label: "Food Critic", suffix: `Scene: animated restaurant table.` },

{ id: "chef_cartoon_master_chef", label: "Master Chef", suffix: `Scene: cartoon chef kitchen.` },

{ id: "chef_cartoon_bakery_star", label: "Bakery Star", suffix: `Scene: animated bakery shop.` },

{ id: "chef_cartoon_kitchen_judge", label: "Kitchen Judge", suffix: `Scene: colorful cartoon kitchen.` },

{ id: "chef_cartoon_plated_pride", label: "Plated Pride", suffix: `Scene: animated kitchen plating scene.` }

],

adventurer: [

/* REAL */

{ id: "adventurer_real_snowy_ridge", label: "Snowy Ridge", suffix: `Scene: snowy mountain ridge.` },

{ id: "adventurer_real_alpine_lake", label: "Alpine Lake", suffix: `Scene: alpine lake surrounded by mountains.` },

{ id: "adventurer_real_forest_trail", label: "Forest Trail", suffix: `Scene: forest hiking trail.` },

{ id: "adventurer_real_desert_overlook", label: "Desert Overlook", suffix: `Scene: desert canyon overlook.` },

{ id: "adventurer_real_peak_watch", label: "Peak Watch", suffix: `Scene: rocky mountain summit.` },

/* HYBRID */

{ id: "adventurer_hybrid_snowbound", label: "Snowbound", suffix: `Scene: illustrated snowy ridge.` },

{ id: "adventurer_hybrid_lake_path", label: "Lake Path", suffix: `Scene: stylized alpine lake trail.` },

{ id: "adventurer_hybrid_forest_guide", label: "Forest Guide", suffix: `Scene: painterly forest trail.` },

{ id: "adventurer_hybrid_desert_trail", label: "Desert Trail", suffix: `Scene: illustrated desert canyon.` },

{ id: "adventurer_hybrid_ridge_hero", label: "Ridge Hero", suffix: `Scene: dramatic mountain ridge.` },

/* CARTOON */

{ id: "adventurer_cartoon_snow_scout", label: "Snow Scout", suffix: `Scene: animated snowy mountain ridge.` },

{ id: "adventurer_cartoon_lake_explorer", label: "Lake Explorer", suffix: `Scene: colorful alpine lake.` },

{ id: "adventurer_cartoon_forest_leader", label: "Forest Leader", suffix: `Scene: animated forest trail.` },

{ id: "adventurer_cartoon_desert_ranger", label: "Desert Ranger", suffix: `Scene: cartoon desert canyon.` },

{ id: "adventurer_cartoon_peak_patrol", label: "Peak Patrol", suffix: `Scene: animated mountain summit.` }

]

};
(function () {
  "use strict";

  const PERSONA_KEYS = new Set([
  "couch_potato",
  "world_pup",
  "adventurer",
  "superhero",
  "royalty",
  "chef",
  "beach_day"
]);
const POSE_OPTIONS = {
  couch_potato: [
    "lounging across a couch",
    "curled into blankets",
    "resting head on pillow",
    "paws forward relaxed pose",
    "reclining diagonally on sofa"
  ],
world_pup: [
  "standing confidently over a soccer ball",
  "seated proudly at midfield",
  "walking forward like entering the pitch",
  "captain-style chest-up pose",
  "poised pre-kickoff stance"
],
  adventurer: [
    "standing proudly on a ridge",
    "stepping forward on a trail",
    "seated on a rock lookout",
    "looking into the distance",
    "bracing against mountain wind"
  ],

  royalty: [
    "seated proudly on a throne",
    "upright noble sit",
    "formal three-quarter portrait pose",
    "calm ceremonial stance",
    "paws-forward regal pose"
  ],

  superhero: [
    "heroic chest-forward stance",
    "rooftop lookout pose",
    "cape flowing hero pose",
    "dynamic landing pose",
    "guardian skyline pose"
  ],

  chef: [
    "seated beside plated dish",
    "standing near kitchen counter",
    "paws near ingredients",
    "proud chef portrait",
    "curious kitchen lean pose"
  ],

  beach_day: [
    "sitting on the sand",
    "standing near shoreline",
    "reclining on beach towel",
    "stepping through shallow surf",
    "looking into ocean breeze"
  ]
};

const CAMERA_OPTIONS = {
  real: [
    "eye-level portrait framing",
    "slightly low-angle portrait",
    "three-quarter editorial framing",
    "centered lifestyle portrait",
    "soft documentary framing"
  ],

  hybrid: [
    "poster-style centered framing",
    "graphic three-quarter composition",
    "stylized hero framing",
    "balanced illustrated portrait",
    "diagonal poster composition"
  ],

  cartoon: [
    "animated feature-film framing",
    "storybook framing",
    "cartoon hero camera angle",
    "playful animated framing",
    "character-centered cartoon shot"
  ]
};
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
  const UC_CDN_BASE = "https://1kk8b9h6qy.ucarecd.net";

  const root = document.querySelector("#nobl-poster-maker");
  if (!root) return;

  const config = {
    apiBase: String(root.getAttribute("data-api-base") || "").trim().replace(/\/+$/, ""),
    overlayUrl: String(root.getAttribute("data-overlay-url") || "").trim(),
    waiverUrl: String(root.getAttribute("data-waiver-url") || "").trim(),
    ucPubKey: String(root.getAttribute("data-uc-pubkey") || "").trim()
  };

  const els = {
  form: root.querySelector("#poster-form"),
  ctxProvider: root.querySelector("#poster-uploader-ctx"),
  hiddenUuid: root.querySelector("#poster-uploadcare"),
  hiddenUrl: root.querySelector("#poster-uploadcare-url"),
  dogName: root.querySelector("#poster-dog-name"),
  email: root.querySelector("#poster-email"),
  optIn: root.querySelector("#poster-opt-in"),
  waiver: root.querySelector("#poster-waiver"),
  turnstileToken: root.querySelector("#poster-turnstile-token"),
  generateBtn: root.querySelector("#poster-generate"),
  status: root.querySelector("#poster-status"),
  error: root.querySelector("#poster-error"),
  spinner: root.querySelector("#poster-spinner"),
  outputImg: root.querySelector("#poster-output"),
  downloadBtn: root.querySelector("#poster-download"),
  copyLinkBtn: root.querySelector("#poster-copy-link"),
  resetBtn: root.querySelector("#poster-reset"),
  shareCopy: root.querySelector("#poster-share-copy")
};

  if (!els.form || !els.ctxProvider || !els.generateBtn || !els.outputImg) {
    console.error("[NOBL Poster] Required DOM elements are missing.");
    return;
  }

  const state = {
    originalUuid: "",
    originalUrl: "",
    uploadReady: false,
    isGenerating: false,
    previewRequestId: "",
    finalPosterBlob: null,
    finalPosterObjectUrl: "",
    finalPosterUuid: "",
    finalPosterUrl: "",
    sharePageUrl: "",
    lastPayload: null,
    renderVariant: null
  };

  const PERSONA_RENDER_STATE = {
  couch_potato: { real: 0, cartoon: 0, hybrid: 0 },
  world_pup: { real: 0, cartoon: 0, hybrid: 0 },
  adventurer: { real: 0, cartoon: 0, hybrid: 0 },
  superhero: { real: 0, cartoon: 0, hybrid: 0 },
  royalty: { real: 0, cartoon: 0, hybrid: 0 },
  chef: { real: 0, cartoon: 0, hybrid: 0 },
  beach_day: { real: 0, cartoon: 0, hybrid: 0 }
};

  function joinUrl(base, path) {
    if (!base) return path;
    return `${base}${path.startsWith("/") ? path : `/${path}`}`;
  }

  function slugify(value) {
    return (
      String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "") || "dog"
    );
  }

  function safeRevokeObjectUrl(url) {
    try {
      if (url) URL.revokeObjectURL(url);
    } catch (_) {}
  }

  function extractUuid(value) {
    const s = String(value || "").trim();
    if (!s) return "";

    const dashed = s.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
    if (dashed) return dashed[0];

    const plain = s.match(/[0-9a-f]{32}/i);
    if (plain) return plain[0];

    const cdn = s.match(/\/([0-9a-f-]{32,36})\//i);
    if (cdn) return cdn[1];

    return "";
  }

  function normalizeEmail(value) {
    const email = String(value || "").trim().toLowerCase();
    return EMAIL_RE.test(email) ? email : "";
  }

  function getSelectedPersona() {
    const checked = els.form.querySelector('input[name="persona"]:checked');
    const value = String(checked?.value || "").trim();
    return PERSONA_KEYS.has(value) ? value : "";
  }

  function getSelectedRenderStyle() {
  const checked = els.form.querySelector('input[name="render_style"]:checked');
  const value = String(checked?.value || "").trim().toLowerCase();

  if (
    value === "realistic" ||
    value === "cartoon" ||
    value === "hybrid" ||
    value === "surprise"
  ) {
    return value;
  }

  return "realistic";
}

function normalizeStyleChoice(style) {
  const value = String(style || "").trim().toLowerCase();

  if (value === "realistic" || value === "real") return "real";
  if (value === "cartoon") return "cartoon";
  if (value === "hybrid") return "hybrid";
  if (value === "surprise") return "hybrid";

  return "real";
}

  function pickRandom(arr) {
    return Array.isArray(arr) && arr.length
      ? arr[Math.floor(Math.random() * arr.length)]
      : null;
  }
function getStyleBucket(renderVariantId = "") {
  if (renderVariantId.includes("_real_")) return "real";
  if (renderVariantId.includes("_hybrid_")) return "hybrid";
  if (renderVariantId.includes("_cartoon_")) return "cartoon";
  return "real";
}

function getPoseAndCameraDirectives(personaKey, renderVariantId) {
  const styleBucket = getStyleBucket(renderVariantId);

  return {
    pose_hint: pickRandom(POSE_OPTIONS[personaKey] || []),
    camera_hint: pickRandom(CAMERA_OPTIONS[styleBucket] || [])
  };
}
  function getRandomPersonaKey() {
    return pickRandom(Array.from(PERSONA_KEYS)) || "couch_potato";
  }

  function getVariantStyleBucket(variantId) {
    const id = String(variantId || "").toLowerCase();
    if (id.includes("_real_")) return "real";
    if (id.includes("_cartoon_")) return "cartoon";
    if (id.includes("_hybrid_")) return "hybrid";
    return "";
  }

  function getNextPersonaRender(personaKey, selectedStyle) {
    const variants = window.PERSONA_STYLE_VARIANTS?.[personaKey] || [];

    if (!variants.length) {
      return window.BASE_RENDER || { id: "base", label: "Poster", suffix: "" };
    }

    if (selectedStyle === "surprise") {
      return pickRandom(variants) || variants[0];
    }

    const styleBucket = normalizeStyleChoice(selectedStyle);
    const matchingVariants = variants.filter(
      (variant) => getVariantStyleBucket(variant.id) === styleBucket
    );

    if (!matchingVariants.length) {
      return variants[0];
    }

    const personaState =
      PERSONA_RENDER_STATE[personaKey] || { real: 0, cartoon: 0, hybrid: 0 };

    const currentIndex = personaState[styleBucket] || 0;
    const selected = matchingVariants[currentIndex % matchingVariants.length];

    personaState[styleBucket] = currentIndex + 1;
    PERSONA_RENDER_STATE[personaKey] = personaState;

    return selected;
  }

  function setStatus(message) {
    if (els.status) els.status.textContent = message || "";
  }

  function setError(message) {
    if (!els.error) return;
    els.error.textContent = message || "";
    els.error.hidden = !message;
  }

  function setLoading(isLoading) {
    state.isGenerating = !!isLoading;
    if (els.spinner) els.spinner.hidden = !isLoading;
    validateReady();
  }

  function clearRenderedPoster() {
    state.finalPosterBlob = null;
    state.finalPosterUuid = "";
    state.finalPosterUrl = "";
    state.sharePageUrl = "";
    state.previewRequestId = "";
    state.lastPayload = null;
    state.renderVariant = null;

    if (state.finalPosterObjectUrl) {
      safeRevokeObjectUrl(state.finalPosterObjectUrl);
      state.finalPosterObjectUrl = "";
    }

    if (els.outputImg) {
      els.outputImg.src = "";
      els.outputImg.hidden = true;
    }

    if (els.downloadBtn) {
      els.downloadBtn.disabled = true;
      els.downloadBtn.removeAttribute("data-download-url");
      els.downloadBtn.removeAttribute("data-download-name");
    }

    if (els.copyLinkBtn) {
      els.copyLinkBtn.disabled = true;
      els.copyLinkBtn.removeAttribute("data-share-url");
    }

    if (els.shareCopy) {
      els.shareCopy.hidden = true;
    }
  }

  function showFinalPoster(blob) {
    if (!blob) {
      throw new Error("No rendered poster blob was returned.");
    }

    state.finalPosterBlob = blob;

    if (state.finalPosterObjectUrl) {
      safeRevokeObjectUrl(state.finalPosterObjectUrl);
      state.finalPosterObjectUrl = "";
    }

    state.finalPosterObjectUrl = URL.createObjectURL(blob);

    if (els.outputImg) {
      els.outputImg.src = state.finalPosterObjectUrl;
      els.outputImg.hidden = false;
    }

    const filename = `nobl-poster-${slugify(els.dogName?.value || "dog")}.png`;

    if (els.downloadBtn) {
      els.downloadBtn.disabled = false;
      els.downloadBtn.dataset.downloadUrl =
        state.finalPosterUrl || state.finalPosterObjectUrl;
      els.downloadBtn.dataset.downloadName = filename;
    }

    if (els.copyLinkBtn) {
      const shareUrl = state.sharePageUrl || state.finalPosterUrl || "";
      els.copyLinkBtn.disabled = !shareUrl;
      if (shareUrl) {
        els.copyLinkBtn.dataset.shareUrl = shareUrl;
      } else {
        els.copyLinkBtn.removeAttribute("data-share-url");
      }
    }

    if (els.shareCopy) {
      els.shareCopy.hidden = false;
    }
  }

  function resetFormState() {
    if (els.form) {
      els.form.reset();
    }

    state.originalUuid = "";
    state.originalUrl = "";
    state.uploadReady = false;
    state.isGenerating = false;

    if (els.hiddenUuid) els.hiddenUuid.value = "";
    if (els.hiddenUrl) els.hiddenUrl.value = "";
    if (els.turnstileToken) els.turnstileToken.value = "";

    clearRenderedPoster();
    setError("");
    setStatus("");

    const defaultStyle = els.form?.querySelector('input[name="render_style"][value="realistic"]');
    if (defaultStyle) {
      defaultStyle.checked = true;
    }

    const cards = root.querySelectorAll("[data-persona-card]");
    cards.forEach((card) => {
      card.removeAttribute("data-selected");
    });

    const uploader = document.querySelector("#poster-uploader");
    if (uploader && typeof uploader.clearAll === "function") {
      try {
        uploader.clearAll();
      } catch (_) {}
    }

    validateReady();
  }

  function updateGenerateButton() {
  const ready = validateReady({ silent: true });
  if (els.generateBtn) {
    els.generateBtn.disabled = !ready;
  }
  return ready;
}

function validateReady(options = {}) {
  const silent = !!options.silent;

  const dogName = String(els.dogName?.value || "").trim();
  const email = normalizeEmail(els.email?.value || "");
  const persona = getSelectedPersona();
  const renderStyle = getSelectedRenderStyle();
  const waiverAccepted = !!els.waiver?.checked;
  const turnstileReady = !!String(els.turnstileToken?.value || "").trim();

  const configOk = !!config.apiBase && !!config.ucPubKey;
  const personaReady = renderStyle === "surprise" ? true : !!persona;

  const ready =
    !!state.uploadReady &&
    !!dogName &&
    !!email &&
    !!personaReady &&
    !!waiverAccepted &&
    !!turnstileReady &&
    !!configOk &&
    !state.isGenerating;

  if (els.generateBtn) {
    els.generateBtn.disabled = !ready;
  }

  if (!silent) {
    console.log("[NOBL Poster] validateReady", {
      uploadReady: state.uploadReady,
      dogName: !!dogName,
      email: !!email,
      persona,
      renderStyle,
      personaReady,
      waiverAccepted,
      turnstileReady,
      configOk,
      isGenerating: state.isGenerating,
      ready
    });
  }

  return ready;
}

function buildPreviewPayload(renderVariant, resolvedPersona) {
  const dog_name = String(els.dogName?.value || "").trim().slice(0, 40);
  const email = normalizeEmail(els.email?.value || "");
  const marketing_opt_in = !!els.optIn?.checked;
  const waiver_accepted = !!els.waiver?.checked;
  const uploadcare_uuid = String(state.originalUuid || "").trim();
  const uploadcare_url = String(state.originalUrl || "").trim();
  const turnstile_token = String(els.turnstileToken?.value || "").trim();

  const selectedStyle = getSelectedRenderStyle();
  const normalizedStyle =
    getVariantStyleBucket(String(renderVariant?.id || "")) ||
    normalizeStyleChoice(selectedStyle) ||
    "real";

  return {
    dog_name,
    email,
    persona: String(resolvedPersona || "").trim(),
    marketing_opt_in,
    waiver_accepted,
    uploadcare_uuid,
    uploadcare_url,
    render_style: normalizedStyle,
    render_variant_id: String(renderVariant?.id || "").trim(),
    render_variant_label: String(renderVariant?.label || "").trim(),
    turnstile_token
  };
}

function assertValidPayload(payload) {
  if (!payload.uploadcare_uuid && !payload.uploadcare_url) {
    throw new Error("Please upload a dog photo before generating.");
  }
  if (!payload.dog_name) {
    throw new Error("Please enter your dog’s name.");
  }
  if (!payload.email || !EMAIL_RE.test(payload.email)) {
    throw new Error("Please enter a valid email address.");
  }
  if (!payload.persona) {
    throw new Error("Please choose a poster persona.");
  }
  if (!payload.waiver_accepted) {
    throw new Error("Please accept the image release and waiver.");
  }
  if (!payload.turnstile_token) {
    throw new Error("Please complete the bot verification.");
  }
}

async function postJson(path, payload) {
  const url = joinUrl(config.apiBase, path);
  const res = await fetch(url, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload)
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed (${res.status})`);
  }

  return res.json().catch(() => ({}));
}

async function logPosterResult(payload, publicPosterUrl) {
  try {
    const renderVariantLabel = String(state.renderVariant?.label || "").trim();

    const logPayload = {
      persona: payload.persona,
      render_style: payload.render_style,
      render_variant_id: payload.render_variant_id,
      render_variant_label: renderVariantLabel,
      dog_name: payload.dog_name,
      email: payload.email,
      marketing_opt_in: payload.marketing_opt_in,
      waiver_accepted: payload.waiver_accepted,
      original_image_uuid: payload.uploadcare_uuid,
      original_image_url: payload.uploadcare_url,
      rendered_image_uuid: state.finalPosterUuid,
      rendered_image_url: publicPosterUrl,
      request_id: state.previewRequestId || ""
    };

    await postJson("/api/log", logPayload);
  } catch (_) {}
}

async function sendPosterEmail(payload, renderedImageUrl) {
  const emailPayload = {
    email: payload.email,
    dog_name: payload.dog_name,
    persona: payload.persona,
    rendered_image_url: renderedImageUrl,
    coupon_code: "NOBLPoster25"
  };

  const emailRes = await fetch(joinUrl(config.apiBase, "/api/email-poster"), {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(emailPayload)
  });

  if (!emailRes.ok) {
    const emailText = await emailRes.text().catch(() => "");
    throw new Error(
      `Email route failed (${emailRes.status})${emailText ? `: ${emailText}` : ""}`
    );
  }

  return emailRes.json().catch(() => ({}));
}

function loadImageFromBlob(blob) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(blob);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(img);
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to load generated image."));
    };

    img.src = objectUrl;
  });
}

function loadImageFromUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Failed to load NOBL overlay image."));
    img.src = url;
  });
}

function drawCover(ctx2d, img, size) {
  const iw = img.naturalWidth || img.width;
  const ih = img.naturalHeight || img.height;

  if (!iw || !ih) {
    throw new Error("Generated image dimensions are invalid.");
  }

  const scale = Math.max(size / iw, size / ih);
  const sw = iw * scale;
  const sh = ih * scale;
  const dx = (size - sw) / 2;
  const dy = (size - sh) / 2;

  ctx2d.drawImage(img, dx, dy, sw, sh);
}

function getPersonaLabel(personaKey) {
  return window.PERSONAS?.[personaKey]?.label || personaKey || "";
}

function drawPosterLabel(ctx2d, canvasSize, personaKey, renderVariantLabel) {
  if (!personaKey || !renderVariantLabel) return;

  const personaLabel = getPersonaLabel(personaKey);
  const caption = `${personaLabel} — ${renderVariantLabel}`;

  const paddingLeft = Math.max(20, Math.round(canvasSize * 0.03));
  const paddingBottom = Math.max(20, Math.round(canvasSize * 0.04));
  const fontSize = Math.max(22, Math.round(canvasSize * 0.028));

  ctx2d.save();
  ctx2d.fillStyle = "rgba(255,255,255,0.96)";
  ctx2d.font = `500 ${fontSize}px Arial, Helvetica, sans-serif`;
  ctx2d.textAlign = "left";
  ctx2d.textBaseline = "alphabetic";
  ctx2d.fillText(caption, paddingLeft, canvasSize - paddingBottom);
  ctx2d.restore();
}

async function composePoster(
  aiBlob,
  overlayUrl,
  outSize,
  personaKey,
  renderVariantLabel
) {
  if (!overlayUrl) {
    throw new Error("Overlay URL is missing.");
  }

  const [aiImg, overlayImg] = await Promise.all([
    loadImageFromBlob(aiBlob),
    loadImageFromUrl(overlayUrl)
  ]);

  const canvas = document.createElement("canvas");
  canvas.width = outSize;
  canvas.height = outSize;

  const ctx2d = canvas.getContext("2d");
  if (!ctx2d) {
    throw new Error("Canvas rendering is not available in this browser.");
  }

  drawCover(ctx2d, aiImg, outSize);
  ctx2d.drawImage(overlayImg, 0, 0, outSize, outSize);
  drawPosterLabel(ctx2d, outSize, personaKey, renderVariantLabel);

  return await new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Poster render failed."));
          return;
        }
        resolve(blob);
      },
      "image/jpeg",
      0.92
    );
  });
}

async function uploadFinalPosterToUploadcare(blob, fileName) {
  if (!config.ucPubKey) {
    throw new Error("Uploadcare public key is missing.");
  }

  const formData = new FormData();
  formData.append("UPLOADCARE_PUB_KEY", config.ucPubKey);
  formData.append("UPLOADCARE_STORE", "1");
  formData.append("file", blob, fileName);

  const res = await fetch("https://upload.uploadcare.com/base/", {
    method: "POST",
    body: formData
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `Failed to save rendered poster. Uploadcare returned ${res.status}${text ? `: ${text}` : ""}`
    );
  }

  const data = await res.json().catch(() => null);
  const rawFile = String(data?.file || "").trim();
  const uuid = extractUuid(rawFile);

  if (!uuid) {
    throw new Error("Rendered poster uploaded, but no Uploadcare UUID was returned.");
  }

  return {
    uuid,
    url: `${UC_CDN_BASE}/${uuid}/`
  };
}
function resetTurnstileIfPresent() {
  try {
    if (window.turnstile && typeof window.turnstile.reset === "function") {
      window.turnstile.reset();
    }
  } catch (_) {}

  if (els.turnstileToken) {
    els.turnstileToken.value = "";
  }
}

async function generatePoster() {
  setError("");

  const selectedStyle = getSelectedRenderStyle();
  const selectedPersona = getSelectedPersona();
  const resolvedPersona =
    selectedStyle === "surprise" ? getRandomPersonaKey() : selectedPersona;

  const renderVariant = getNextPersonaRender(resolvedPersona, selectedStyle);
  const payload = buildPreviewPayload(renderVariant, resolvedPersona);

  assertValidPayload(payload);

  clearRenderedPoster();
  state.lastPayload = payload;
  state.renderVariant = renderVariant;

  setLoading(true);
  setStatus("Generating poster… this can take a few seconds.");

  try {
    console.log("[NOBL Poster] preview payload", payload);
    
    const response = await fetch(joinUrl(config.apiBase, "/api/preview"), {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload)
    });

    const reqId =
      response.headers.get("x-request-id") ||
      response.headers.get("X-Request-Id") ||
      "";

    state.previewRequestId = reqId;

    if (!response.ok) {
      let detail = "Generation failed.";
      try {
        const data = await response.json();
        detail = data?.error || data?.message || detail;
        if (data?.upstream) detail += ` | upstream=${data.upstream}`;
        if (data?.reqId) detail += ` | reqId=${data.reqId}`;
      } catch (_) {}
      throw new Error(detail);
    }

    const aiBlob = await response.blob();

    const composedBlob = await composePoster(
      aiBlob,
      config.overlayUrl,
      3000,
      payload.persona,
      String(renderVariant?.label || "").trim()
    );

    const uploadedFinal = await uploadFinalPosterToUploadcare(
      composedBlob,
      `nobl-poster-${slugify(payload.dog_name)}.jpg`
    );

    if (uploadedFinal?.uuid) {
      state.finalPosterUuid = uploadedFinal.uuid;
    }

    if (uploadedFinal?.url) {
      state.finalPosterUrl = uploadedFinal.url;
      state.sharePageUrl = uploadedFinal.url;
    }

    showFinalPoster(composedBlob);

    if (els.copyLinkBtn) {
      els.copyLinkBtn.disabled = !state.sharePageUrl;
      if (state.sharePageUrl) {
        els.copyLinkBtn.dataset.shareUrl = state.sharePageUrl;
      } else {
        els.copyLinkBtn.removeAttribute("data-share-url");
      }
    }

    await logPosterResult(payload, state.finalPosterUrl);

    try {
      await sendPosterEmail(payload, state.finalPosterUrl);
    } catch (err) {
      console.warn("[NOBL Poster] Email send failed:", err);
    }

    setStatus("Poster ready.");
  } catch (err) {
    setError(err?.message || "Unable to generate poster.");
    clearRenderedPoster();
 } finally {
  resetTurnstileIfPresent();
  setLoading(false);
  validateReady();
}
}

async function handleDownloadClick() {
  const rawUrl =
    String(els.downloadBtn?.dataset.downloadUrl || "").trim() ||
    state.finalPosterUrl ||
    state.finalPosterObjectUrl ||
    "";

  if (!rawUrl) {
    setStatus("Download unavailable.");
    return;
  }

  const filename =
    String(els.downloadBtn?.dataset.downloadName || "").trim() ||
    `nobl-poster-${slugify(els.dogName?.value || "dog")}.jpg`;

  try {
    const res = await fetch(rawUrl, { mode: "cors" });
    if (!res.ok) {
      throw new Error(`Download fetch failed (${res.status})`);
    }

    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      try {
        URL.revokeObjectURL(objectUrl);
      } catch (_) {}
    }, 1500);

    setStatus("Poster downloaded.");
  } catch (_) {
    setStatus("Download failed.");
  }
}
async function handleCopyLinkClick() {
  const url =
    String(els.copyLinkBtn?.dataset.shareUrl || "").trim() ||
    state.sharePageUrl ||
    state.finalPosterUrl ||
    "";

  if (!url) return;

  try {
    await navigator.clipboard.writeText(url);
    setStatus("Share link copied.");
  } catch (_) {
    const input = document.createElement("input");
    input.value = url;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, input.value.length);
    document.execCommand("copy");
    input.remove();
    setStatus("Share link copied.");
  }
}

function bindUploader() {
  const ctx = els.ctxProvider;
  if (!ctx) return;

  const applyUploadEntry = (entry) => {
    const detail = entry?.detail || entry || {};

    const cdnUrl = String(
      detail.cdnUrl ||
        detail.cdn_url ||
        detail.originalUrl ||
        detail.url ||
        detail.fileInfo?.cdnUrl ||
        detail.fileInfo?.cdn_url ||
        detail.fileInfo?.originalUrl ||
        detail.fileInfo?.url ||
        detail.file?.cdnUrl ||
        detail.file?.cdn_url ||
        detail.file?.originalUrl ||
        detail.file?.url ||
        detail.output?.cdnUrl ||
        detail.output?.cdn_url ||
        detail.output?.originalUrl ||
        detail.output?.url ||
        ""
    ).trim();

    const uuid = String(
      detail.uuid ||
        detail.fileInfo?.uuid ||
        detail.file?.uuid ||
        detail.output?.uuid ||
        extractUuid(cdnUrl) ||
        ""
    ).trim();

    state.originalUuid = uuid;
    state.originalUrl = cdnUrl || (uuid ? `${UC_CDN_BASE}/${uuid}/` : "");
    state.uploadReady = !!(state.originalUuid || state.originalUrl);

    if (els.hiddenUuid) els.hiddenUuid.value = state.originalUuid;
    if (els.hiddenUrl) els.hiddenUrl.value = state.originalUrl;

    clearRenderedPoster();
    setError("");
    setStatus(state.uploadReady ? "Photo uploaded." : "");
    validateReady();
  };

  const clearUpload = () => {
    state.originalUuid = "";
    state.originalUrl = "";
    state.uploadReady = false;

    if (els.hiddenUuid) els.hiddenUuid.value = "";
    if (els.hiddenUrl) els.hiddenUrl.value = "";

    clearRenderedPoster();
    validateReady();
  };

  const trySyncFromApi = () => {
    try {
      const api = typeof ctx.getAPI === "function" ? ctx.getAPI() : null;
      if (!api) return false;

      const output =
        (typeof api.getOutputCollectionState === "function" &&
          api.getOutputCollectionState()) ||
        (typeof api.getOutputState === "function" && api.getOutputState()) ||
        null;

      const first =
        output?.successEntries?.[0] ||
        output?.entries?.find((x) => x?.status === "success") ||
        output?.allEntries?.find((x) => x?.status === "success") ||
        null;

      if (first) {
        applyUploadEntry(first);
        return true;
      }
    } catch (err) {
      console.warn("[NOBL Poster] Uploadcare API sync failed:", err);
    }

    return false;
  };

  ctx.addEventListener("file-upload-success", applyUploadEntry);
  ctx.addEventListener("common-upload-success", applyUploadEntry);

  ctx.addEventListener("change", (event) => {
    const detail = event?.detail || event || {};
    const hasImmediateData = !!(
      detail?.cdnUrl ||
      detail?.cdn_url ||
      detail?.originalUrl ||
      detail?.url ||
      detail?.uuid ||
      detail?.fileInfo?.uuid ||
      detail?.fileInfo?.cdnUrl ||
      detail?.fileInfo?.cdn_url ||
      detail?.fileInfo?.originalUrl ||
      detail?.file?.uuid ||
      detail?.file?.cdnUrl ||
      detail?.file?.cdn_url ||
      detail?.file?.originalUrl ||
      detail?.output?.uuid ||
      detail?.output?.cdnUrl ||
      detail?.output?.cdn_url ||
      detail?.output?.originalUrl
    );

    if (hasImmediateData) {
      applyUploadEntry(event);
    } else {
      trySyncFromApi();
      validateReady();
    }
  });

  ctx.addEventListener("modal-close", () => {
    trySyncFromApi();
    validateReady();
  });

  ctx.addEventListener("file-removed", clearUpload);
  ctx.addEventListener("remove", clearUpload);

  ctx.addEventListener("file-upload-failed", () => {
    clearUpload();
    setError("Image upload failed. Please try again.");
  });

  setTimeout(() => {
    trySyncFromApi();
    validateReady();
  }, 250);

  setTimeout(() => {
    trySyncFromApi();
    validateReady();
  }, 1000);
}

function bindPersonaCards() {
  const cards = Array.from(root.querySelectorAll("[data-persona-card]"));

  cards.forEach((card) => {
    const input = card.querySelector('input[name="persona"]');
    if (!input) return;

    const sync = () => {
      if (input.checked) {
        card.setAttribute("data-selected", "true");
      } else {
        card.removeAttribute("data-selected");
      }
    };

    input.addEventListener("change", () => {
      cards.forEach((c) => c.removeAttribute("data-selected"));
      sync();
      validateReady();
    });

    sync();
  });
}

function bindForm() {
  if (!els.form) return;

  els.form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!validateReady()) return;
    await generatePoster();
  });

  if (els.generateBtn) {
    els.generateBtn.addEventListener("click", async (event) => {
      const type = String(els.generateBtn.getAttribute("type") || "").toLowerCase();
      if (type === "button") {
        event.preventDefault();
        if (!validateReady()) return;
        await generatePoster();
      }
    });
  }

  ["input", "change"].forEach((evtName) => {
    els.form.addEventListener(evtName, () => {
      setError("");
      validateReady();
    });
  });

  if (els.resetBtn) {
    els.resetBtn.addEventListener("click", (event) => {
      event.preventDefault();
      resetFormState();
    });
  }

  if (els.downloadBtn) {
    els.downloadBtn.addEventListener("click", (event) => {
      event.preventDefault();
      handleDownloadClick();
    });
  }

  if (els.copyLinkBtn) {
    els.copyLinkBtn.addEventListener("click", (event) => {
      event.preventDefault();
      handleCopyLinkClick();
    });
  }
}

function init() {
  if (!config.apiBase) {
    setError("Missing API base URL.");
    return;
  }

  bindUploader();
  bindPersonaCards();
  bindForm();
  validateReady();
}

init();
})();